<template>
  <div id="scroll-board">
    <module-title title="今日商品销售 TOP15" ref="title"/>
    <div class="topbox">
      <el-row class="itemrow">
        <el-col :span="2">
          <div class="text">序号</div>
        </el-col>
        <el-col :span="10">
          <div class="text">品名</div>
        </el-col>
        <el-col :span="6">
          <div class="text">销量</div>
        </el-col>
        <el-col :span="6">
          <div class="text">销售金额</div>
        </el-col>
      </el-row>
      <el-carousel style="width: 26vw; height: 37.1vh;" direction="vertical" 
      :autoplay="true" indicator-position="none" @change="pageChange">
        <el-carousel-item v-for="(page, index) in pageData" :key="index">

          <el-row v-for="(item, aindex) in page.arr" :key="aindex" class="datarow">
            <el-col :span="2">
              <div class="text">{{ item.SaleRank||0 }}</div>
            </el-col>
            <el-col :span="10">
              <div class="text">{{ item.ItemName||0 }}</div>
            </el-col>
            <el-col :span="6">
              <div class="text">{{ item.SaleQty||0 }}</div>
            </el-col>
            <el-col :span="6">
              <div class="text">{{ item.SaleAmount||0 }}</div>
            </el-col>
          </el-row>

        </el-carousel-item>

      </el-carousel>
    </div>
  </div>
</template>

<script>
import moduleTitle from '@/components/Common/ModuleTitle.vue';

export default {
  name: 'ScrollBoard',
  components: {
    moduleTitle
  },
  props: {
    data: {
      type: Array,
      default: () => [
        {
          ItemId: 877001,
          ItemCode: "04041",
          ItemSelfCode: null,
          ItemName: "红心火龙果",
          SaleRank: 1,
          RankChange: 0,
          SaleQty: 1.0000,
          SaleAmount: 30.0000,
          SaleQtyCompare: null,
          SaleAmountCompare: null,
          SaleQtyPercent: null,
          SaleAmountPercent: null
        },
        {
          ItemId: 877001,
          ItemCode: "04041",
          ItemSelfCode: null,
          ItemName: "红心火龙果",
          SaleRank: 1,
          RankChange: 0,
          SaleQty: 1.0000,
          SaleAmount: 30.0000,
          SaleQtyCompare: null,
          SaleAmountCompare: null,
          SaleQtyPercent: null,
          SaleAmountPercent: null
        },        {
          ItemId: 877001,
          ItemCode: "04041",
          ItemSelfCode: null,
          ItemName: "红心火龙果",
          SaleRank: 1,
          RankChange: 0,
          SaleQty: 1.0000,
          SaleAmount: 30.0000,
          SaleQtyCompare: null,
          SaleAmountCompare: null,
          SaleQtyPercent: null,
          SaleAmountPercent: null
        },        {
          ItemId: 877001,
          ItemCode: "04041",
          ItemSelfCode: null,
          ItemName: "红心火龙果",
          SaleRank: 1,
          RankChange: 0,
          SaleQty: 1.0000,
          SaleAmount: 30.0000,
          SaleQtyCompare: null,
          SaleAmountCompare: null,
          SaleQtyPercent: null,
          SaleAmountPercent: null
        },        {
          ItemId: 877001,
          ItemCode: "04041",
          ItemSelfCode: null,
          ItemName: "红心火龙果",
          SaleRank: 1,
          RankChange: 0,
          SaleQty: 1.0000,
          SaleAmount: 30.0000,
          SaleQtyCompare: null,
          SaleAmountCompare: null,
          SaleQtyPercent: null,
          SaleAmountPercent: null
        }
      ],
    }
  },
  data() {
    return {
      pageTotal: 1,
      pageSize: 8,
      total: 8,
      pageData: [],
      config: {
        index: true,
        align: ['center'],
        rowNum: 7,
        headerBGC: '#1981f6',
        headerHeight: 45,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      }
    }
  },
  watch: {
    data: {
      handler: function (newData) {
        if (newData.length == 0) return;
        this.intData(newData);
      },
      deep: true
    }
  },
  mounted() {
    if (this.data && this.data.length > 0)
      this.intData(this.data);
  },
  methods: {
    intData(val) {
      this.pageData = [];
      this.total = val.length;
      this.pageTotal = parseInt(this.total / this.pageSize) + 1;
      for (let i = 0; i < this.pageTotal; i++) {
        this.pageData.push({ arr: val.slice(i * this.pageSize, (i + 1) * this.pageSize) });
      }
      this.$refs.title.setPage(1,this.pageTotal);

      console.log('pageData', this.pageData);
    },
    pageChange(val) {
      this.$refs.title.setPage(val+1,this.pageTotal);
      // console.log('pageChange', val);
    }
  }

}
</script>

<style lang="less" scoped>
#scroll-board {
  width: 100%;
  position: relative;

  height: 100%;
  overflow: hidden;
  background: rgba(24, 50, 148, 0.30);
  border: none;
  border-radius: 8px;

  .topbox {
    border-radius: 8px;

  }

  .itemrow {
    height: 4.625vh;
    display: flex;
    /* 使用 Flexbox 布局 */
    align-items: center;

    /* 垂直居中 */
    &:nth-child(odd) {

      background: linear-gradient(270deg, rgba(29, 123, 188, 0.00), rgba(66, 160, 226, 0.3));
    }

    // &:nth-child(even) {
    //   background-color: rgba(10, 29, 50, 0.8);
    // }
  }

  .datarow {
    height: 4.625vh;
    display: flex;
    /* 使用 Flexbox 布局 */
    align-items: center;

    /* 垂直居中 */
    &:nth-child(even) {
      background: linear-gradient(270deg, rgba(29, 123, 188, 0.00), rgba(66, 160, 226, 0.3));
    }
  }
}

#scroll-board::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 8px;
  background: linear-gradient(156deg, rgba(255, 255, 255, 0.3) 8%, rgba(255, 255, 255, 0.00) 91%);
  mask:
    linear-gradient(#221f1f 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  padding: 1px;
  /* 边框宽度 */
}
</style>
